// One place for how report charts and figures look, so sixteen screens stay identical.

// Series colours: the four logo colours first (navy, green, gold, sky blue), then distinguishable
// companions. Alerts are rose.
export const PALETTE = ['#003078', '#009038', '#c88800', '#00a0c4', '#8b5cf6', '#64748b', '#ec4899', '#84cc16'];
export const ALERT = '#e11d48';

/**
 * One colour per bar, for bar charts that show a single series (Top diagnoses, Doctor load, Top
 * payers...): every bar its own colour, so a bar is easy to match to its label and to the row of the
 * table under the chart (owner, 2026-10-01). The four logo colours lead, then twelve distinct
 * companions; a chart longer than sixteen bars (Supplies Given, Vendor Purchases are not capped)
 * goes on with colours stepped round the colour wheel by the golden angle, so no two bars ever
 * share one. Charts comparing several series keep one colour per series instead, because
 * there the colour IS the legend, and charts whose bar colour means something (Frequent Patients'
 * grey below the minimum, Receivables' red for overdue) keep that meaning.
 */
export const BAR_COLORS = [
  '#003078', '#009038', '#c88800', '#00a0c4', '#7c3aed', '#ea580c',
  '#0d9488', '#db2777', '#2563eb', '#65a30d', '#c026d3', '#475569',
  '#4f46e5', '#be123c', '#a16207', '#0891b2',
];
export const barColor = (i) =>
  i < BAR_COLORS.length ? BAR_COLORS[i] : `hsl(${Math.round((i * 137.508) % 360)}, 60%, 40%)`;
export const GRID = '#e5e7eb';

/** Shared axis styling: quiet grey, small type, no axis lines fighting the grid. */
export const axisProps = {
  stroke: '#9ca3af',
  fontSize: 11,
  tickLine: false,
  axisLine: false,
};

/**
 * Tooltip container matched to the app's cards. Its text stays in ink rather than each series'
 * colour: the series name says which one it is, and a pale series colour on white is hard to read.
 */
export const tooltipStyle = {
  contentStyle: {
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '0.75rem',
    boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    fontSize: 12,
  },
  itemStyle: { color: '#374151' },
  labelStyle: { color: '#6b7280' },
};

/** Rupee amount for display: grouped, no decimals for whole amounts, 2dp otherwise. */
export const fmtMoney = (v) => {
  const n = Number(v);
  if (!isFinite(n)) return '—';
  const opts = Number.isInteger(n) ? {} : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  return `Rs ${n.toLocaleString('en-PK', opts)}`;
};

/** Plain count with thousands grouping. */
export const fmtNum = (v) => {
  const n = Number(v);
  return isFinite(n) ? n.toLocaleString('en-PK') : '—';
};

/** Compact money for chart axes: 12.5K / 1.2M. */
export const fmtMoneyShort = (v) => {
  const n = Number(v);
  if (!isFinite(n)) return '';
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
  return String(n);
};
